module.exports = __webpack_public_path__ + "static/media/moto-art-wloszczowa.93bb38c9.png";